import React from 'react';
import {addSeparator} from "core/common/utils/arrayUtils";


import 'core/components/blockComp/blockComp.less';
import {observer} from "mobx-react";
import {classNames} from "core/common/utils/domUtils";
import {grey300} from "material-ui/styles/colors";


interface BlockCompProps {
  header?: any;
  headerStyle?: any;
  style?: any,
  className?: string,
  noPadding?: boolean
}


export const BlockComp = observer( ({header, style, headerStyle, className, noPadding, children, ...other}: BlockCompProps & { children?: React.ReactNode }) => {

  let bcClass = classNames({'block-comp': !noPadding, 'block-comp-no-padding': noPadding}, className);

  if (header) {
    let margin = (noPadding) ? '10px 15px 5px 15px' : '0 0 10px 0';
    return (
      <div className={bcClass} style={style}>
        <h5 style={Object.assign({margin, fontSize: '18px'}, headerStyle)}>{header}</h5>
        <div>{children}</div>
      </div>
    );
  } else {
    return (
      <div className={bcClass} style={style}>
        {children}
      </div>
    );
  }
});


interface MdDividerProps {
  inset?: boolean;
  hide?: boolean;
  marginTop?: number;
  marginBottom?: number;
  marginRight?: number;
  marginLeft?: number;
}

export const MdDivider = ({inset, hide, marginTop, marginBottom, marginRight, marginLeft}: MdDividerProps) => (
  (!hide) ? <hr style={{
    marginTop: (marginTop == null) ? 0 : marginTop,
    marginBottom: (marginBottom == null) ? 0 : marginBottom,
    marginLeft: (marginLeft == null) ? ((inset)?20:0) : marginLeft,
    marginRight: (inset)?20: ((marginRight == null)?0:marginRight),
    border: 'none',
    height: 1,
    backgroundColor: grey300
  }}/> : <noscript/>
);

export const MdVerticalDivider = ({inset, hide}: {inset?: boolean; hide?: boolean}) => (
  (!hide) ? <div style={{
    marginTop: (inset)?20:0,
    marginBottom: (inset)?20:0,
    width: 1,
    minWidth: 1,
    backgroundColor: grey300
  }}/> : <noscript/>
);


interface MdBlockArrayProps {
  className?: string;
  inset?: boolean;
  children?: React.ReactNode[];
}

export const MdBlockArray = ({className, inset, children}: MdBlockArrayProps) =>
  (<div className={className}>
    {addSeparator(React.Children.toArray(children), <MdDivider inset={inset}/>)}
  </div>);



// WEBPACK FOOTER //
// ./src/core/components/blockComp/blockComp.tsx